module.exports = __webpack_public_path__ + "static/media/seminar.4f5b43a1.svg";